<template>
  <FormInput v-model="value" />
</template>
<script>

// TODO
export default {
  props: ["column", "modelValue"],
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
}
</script>
